module.exports = __webpack_public_path__ + "static/img/course_img.611a516d.jpg";